import * as React from "react";
import { SVGProps } from "react";
const SvgRewind = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.75 9.12A2.166 2.166 0 0 1 16 10.996v4.976c.01-.762.42-1.466 1.083-1.848L25.75 9.12A2.165 2.165 0 0 1 29 10.996v10.007a2.165 2.165 0 0 1-3.25 1.877l-8.667-5.005A2.166 2.166 0 0 1 16 16v5.003c0 .72-.356 1.388-.944 1.789l-.14.087a2.16 2.16 0 0 1-2.165 0l-8.668-5.004a2.165 2.165 0 0 1 0-3.752L12.75 9.12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRewind;
